import Vue from 'vue';
// import ws from '@/utils/ws';
import ws from '@/utils/ws/index';
import { mixins } from '@zk/framework-vue';
import { merge } from 'lodash';
const { Websocket: wsMixin } = mixins;
Vue.prototype.$socket = ws;

Vue.config.optionMergeStrategies.socketEvents = (parent, child) => {
  return merge({}, parent, child);
};
Vue.mixin(wsMixin);
